import React, { useState } from 'react';
import api, { getApiErrorMessage } from '../services/api';

export default function AdminPasswordRecovery({ installed = process.env.REACT_APP_DISTRIBUTION === 'true' || window.location.port === '8765' }) {
  const [open, setOpen] = useState(false);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  if (!installed) return null;
  const request = async () => {
    setBusy(true); setError('');
    try {
      const { data } = await api.post('/auth/admin-recovery/request');
      setMessage(data.message);
    } catch (err) { setError(getApiErrorMessage(err)); }
    finally { setBusy(false); }
  };
  return <div className="mt-4">
    <button type="button" onClick={() => { setOpen(true); setMessage(''); setError(''); }} className="text-sm font-semibold text-teal-700 underline">Esqueci minha senha</button>
    {open && <div role="dialog" aria-modal="true" aria-labelledby="admin-recovery-title" className="fixed inset-0 z-[60] flex items-center justify-center bg-slate-950/60 p-4">
      <section className="w-full max-w-md rounded-2xl bg-white p-6 text-slate-800 shadow-xl">
        <h3 id="admin-recovery-title" className="text-lg font-semibold">Recuperação do administrador</h3>
        <p className="mt-3 text-sm text-slate-600">Somente para o usuário admin deste condomínio. Envie uma solicitação ao responsável pelo sistema para que ele defina e forneça uma nova senha. É necessário estar conectado à internet.</p>
        {error && <p role="alert" className="mt-3 text-sm text-red-700">{error}</p>}
        {message && <p role="status" className="mt-3 text-sm text-teal-700">{message}</p>}
        <div className="mt-5 flex flex-wrap justify-end gap-3">
          <button type="button" disabled={busy} onClick={() => setOpen(false)} className="rounded-xl border px-4 py-2 text-sm">Fechar</button>
          {!message && <button type="button" disabled={busy} onClick={request} className="rounded-xl bg-teal-700 px-4 py-2 text-sm font-semibold text-white disabled:opacity-50">{busy ? 'Enviando…' : 'Solicitar recuperação de senha'}</button>}
        </div>
      </section>
    </div>}
  </div>;
}
